import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var trending_up_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M3.445 16.505a.75.75 0 001.06.05l5.005-4.55 4.024 3.521 4.716-4.715V14h1.5V8.25H14v1.5h3.19l-3.724 3.723L9.49 9.995l-5.995 5.45a.75.75 0 00-.05 1.06z" }) });
export {
  trending_up_default as default
};
//# sourceMappingURL=trending-up.js.map
